import tw from 'tailwind-styled-components'
import {Hub} from 'yougile-model'
import {Lang} from 'yougile-lang'
import * as React from 'react'
import {EventBus} from '@client/event-bus'
import {openProjectParticipants} from '@client/events'
import PlusIcon from './add.svg'
import {LinkButtonSmall} from '@components/common/button/button'

interface Props {
  project: Hub
  onClick: () => void
}

const TwAddUsersButton = tw.div`
    h-32
    flex
    items-center
`
export const AddUsersButton = (props: Props) => {
  return (
    <TwAddUsersButton>
      <LinkButtonSmall
        data-test="add-users-button"
        onClick={() => {
          props.onClick()
          EventBus.dispatch(openProjectParticipants(props.project))
        }}
        className="flex items-center"
      >
        <PlusIcon className="mr-6" />
        {Lang.msg.permission.addUsersToProject}
      </LinkButtonSmall>
    </TwAddUsersButton>
  )
}
